module.exports = __webpack_public_path__ + "img/بنر-سایت.fc78bde7.png";